export default __webpack_public_path__ + "static/coffee2-680c076d5b3ec7dd8b73a9bf44622e11.png";